const knowInvoiceInsert = 'Conocer si Boleta/Factura esta ingresada';
const invoicePaymentDate = 'Fecha pago Boleta/Factura';
const detailsMyPayment = 'Conocer detalle de mi pago';

const MOTIVES = [
  {
    id: knowInvoiceInsert,
    name: knowInvoiceInsert,
  },
  {
    id: invoicePaymentDate,
    name: invoicePaymentDate,
  },
  {
    id: detailsMyPayment,
    name: detailsMyPayment,
  },
];

export const optionMapper = new Map([['motive', MOTIVES]]);
